import {
  defineCborSchema,
  CborField,
  type CborSchema,
} from '@mesh/friendly-cbor-serializer'
import {
  type ResponseHeader,
  ResponseHeaderSchema,
} from '../responseHeader'
import {
  type RegisterClientResponsePayload,
  RegisterClientResponsePayloadSchema,
} from './registerClientResponsePayload'

export type RegisterClientResponse = {
  header: ResponseHeader
  payload?: RegisterClientResponsePayload
}

export const RegisterClientResponseSchema: CborSchema<RegisterClientResponse> =
  defineCborSchema<RegisterClientResponse>({
    header: CborField({ key: 0, type: ResponseHeaderSchema }),
    payload: CborField({ key: 1, required: false, type: RegisterClientResponsePayloadSchema }),
  })
